import React from 'react'

const ArrowIconUp: React.FC = () => {
  return (
    <svg
      width="24"
      height="15"
      viewBox="0 0 24 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 13L12 3L22 13"
        stroke="white"
        stroke-width="3"
        stroke-linecap="round"
      />
    </svg>
  )
}

export default ArrowIconUp
